import { Ability } from '@casl/ability';

const defaultAbilities = [{ actions: 'read', subject: 'all' }];
export const ability = new Ability(defaultAbilities);

export const resetAbility = () => ability.update(defaultAbilities);
export default ability;
